import React, {useEffect, useState} from 'react'
import linkBoxesStyle from "../components/css/linkBoxes.module.scss";
import Box from '../components/box'

export default function({children, linksData}){
    console.log(linksData);
    return (
        <div className={linkBoxesStyle.container}>
            {
                linksData.map(link=>{
                    return <div className={linkBoxesStyle.boxes}><Box label={link.name} instructor={link.spec} icon={link.icon} slug={link.slug}/></div>
                })
            }
        </div>
    )
}